<script lang="ts" setup>
import LocationsMenu from '../components/locations/LocationsMenu.vue';
import LocationsList from '../components/locations/LocationsList.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<template>
  <LocationsMenu />
  <LocationsList v-if="route.path === '/locations'" />
</template>
